import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResultIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 110,
	height: 88,
	viewBox: "0 0 110 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M58.6952 87.3903C82.275 87.3903 101.39 68.275 101.39 44.6952C101.39 21.1153 82.275 2 58.6952 2C35.1153 2 16 21.1153 16 44.6952C16 68.275 35.1153 87.3903 58.6952 87.3903Z",
			fill: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .86,
			d: "M58.6952 87.3903C82.275 87.3903 101.39 68.275 101.39 44.6952C101.39 21.1153 82.275 2 58.6952 2C35.1153 2 16 21.1153 16 44.6952C16 68.275 35.1153 87.3903 58.6952 87.3903Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M36.2224 45.3516L45.1223 58.0189L30.2418 60.4945L25.2578 53.7693L36.2224 45.3516Z",
			fill: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M93.5321 25.8702L87.5515 20.8906L80.9062 30.2944L82.985 32.6995L93.5321 25.8702Z",
			fill: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M32.3984 30.297L37.8981 26.1914L42.5366 33.7286L37.1844 36.54L32.3984 30.297Z",
			fill: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M64.8516 75.8298L71.1805 70.6797L75.0892 75.8298L68.0409 80.6474L64.8516 75.8298Z",
			fill: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M39.5156 38.6142L45.259 34.418L49.84 40.4416L47.3482 42.9868L51.0597 47.7748L54.4917 45.3512L58.4905 50.4094L51.0597 55.8916L39.5156 38.6142Z",
			fill: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.325 47.0265L79.9358 61.508L89.7883 73.9502C89.4953 74.2629 89.1972 74.5705 88.8939 74.8728L78.8957 62.2467L61.5235 75.1969L69.2178 86.0824C68.7748 86.1956 68.329 86.3008 67.8804 86.398L60.1253 75.4248L49.244 60.2513L30.1944 64.0892L31.7185 77.7895C31.2374 77.3975 30.7657 76.9951 30.3034 76.5824L28.8868 63.8472L16.2352 49.2115C16.1587 48.5011 16.1012 47.7855 16.0625 47.0647L29.7359 62.8835L48.4289 59.1163L22.1926 22.5327C22.4303 22.1407 22.6747 21.753 22.9257 21.3695L49.7983 58.8404L49.9455 58.8107L69.5485 45.017L55.6628 26.9905L57.6681 2.01274C58.0092 2.00424 58.3507 2 58.6927 2C58.7776 2 58.8625 2 58.9474 2.00141L56.9719 26.6028L70.5915 44.2825L96.9547 25.7324C97.1472 26.1174 97.333 26.5061 97.5123 26.8985L50.5753 59.9244L60.7843 74.1596L79.1264 60.4865L79.1433 60.5077L101.38 45.4517C101.371 45.9793 101.353 46.5029 101.325 47.0265Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.6306 12C41.6631 12 32 21.6732 32 33.6042C32 37.3558 33.4241 41.5815 34.6391 43.961C38.6275 51.7767 53.3903 73.6305 53.3903 73.6305C53.4152 73.6722 53.4506 73.7068 53.4929 73.7308C53.5352 73.7548 53.583 73.7674 53.6316 73.7674C53.6803 73.7674 53.7281 73.7548 53.7704 73.7308C53.8127 73.7068 53.848 73.6722 53.873 73.6305C53.873 73.6305 68.6356 51.7767 72.6241 43.961C73.8386 41.581 75.2631 37.3558 75.2631 33.6042C75.2631 21.6726 65.5999 12 53.6325 12H53.6306Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .12,
			d: "M53.6306 12C41.6631 12 32 21.6732 32 33.6042C32 37.3558 33.4241 41.5815 34.6391 43.961C38.6275 51.7767 53.3903 73.6305 53.3903 73.6305C53.4152 73.6722 53.4506 73.7068 53.4929 73.7308C53.5352 73.7548 53.583 73.7674 53.6316 73.7674C53.6803 73.7674 53.7281 73.7548 53.7704 73.7308C53.8127 73.7068 53.848 73.6722 53.873 73.6305C53.873 73.6305 68.6356 51.7767 72.6241 43.961C73.8386 41.581 75.2631 37.3558 75.2631 33.6042C75.2631 21.6726 65.5999 12 53.6325 12H53.6306Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.1684 15.3885C53.3236 15.3845 53.4774 15.3885 53.6335 15.3885C56.0318 15.3885 58.4062 15.8652 60.6187 16.7909C62.8312 17.7166 64.8376 19.0728 66.5213 20.7807C68.2051 22.4886 69.5326 24.5142 70.4266 26.7396C71.3207 28.965 71.7635 31.346 71.7294 33.7441C71.5932 43.4911 63.6382 51.4468 53.8907 51.5819C49.1163 51.6377 44.5132 49.8048 41.0839 46.4824C37.6546 43.16 35.677 38.6172 35.5817 33.8434C35.4865 29.0696 37.2812 24.4515 40.5752 20.9949C43.8692 17.5383 48.3955 15.5232 53.1684 15.3885Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.3754 72.3754L83.2323 64.2323L91.3754 72.3754ZM83.2323 64.2323C84.6252 62.8393 85.7301 61.1857 86.4839 59.3658C87.2378 57.5459 87.6258 55.5953 87.6258 53.6254C87.6258 51.6555 87.2378 49.7049 86.4839 47.885C85.7301 46.0651 84.6252 44.4114 83.2323 43.0185C81.8393 41.6256 80.1857 40.5207 78.3658 39.7668C76.5459 39.013 74.5953 38.625 72.6254 38.625C70.6555 38.625 68.7049 39.013 66.885 39.7668C65.0651 40.5207 63.4114 41.6256 62.0185 43.0185C59.2054 45.8316 57.625 49.647 57.625 53.6254C57.625 57.6037 59.2054 61.4191 62.0185 64.2323C64.8316 67.0454 68.647 68.6258 72.6254 68.6258C76.6037 68.6258 80.4191 67.0454 83.2323 64.2323Z",
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.3754 72.3754L83.2323 64.2323M83.2323 64.2323C84.6252 62.8393 85.7301 61.1857 86.4839 59.3658C87.2378 57.5459 87.6258 55.5953 87.6258 53.6254C87.6258 51.6555 87.2378 49.7049 86.4839 47.885C85.7301 46.0651 84.6252 44.4114 83.2323 43.0185C81.8393 41.6256 80.1857 40.5207 78.3658 39.7668C76.5459 39.013 74.5953 38.625 72.6254 38.625C70.6555 38.625 68.7049 39.013 66.885 39.7668C65.0651 40.5207 63.4114 41.6256 62.0185 43.0185C59.2054 45.8316 57.625 49.647 57.625 53.6254C57.625 57.6037 59.2054 61.4191 62.0185 64.2323C64.8316 67.0454 68.647 68.6258 72.6254 68.6258C76.6037 68.6258 80.4191 67.0454 83.2323 64.2323Z",
			stroke: "#A0A0A0",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.8746 53.6601C83.8677 55.8859 83.2006 58.0596 81.958 59.9061C80.7153 61.7527 78.9528 63.1891 76.8935 64.0337C74.8342 64.8782 72.5706 65.0929 70.3893 64.6506C68.2079 64.2083 66.2068 63.1289 64.6391 61.5489C63.0714 59.9689 62.0076 57.9594 61.5823 55.7746C61.157 53.5899 61.3893 51.3281 62.2499 49.2754C63.1104 47.2227 64.5605 45.4714 66.4166 44.2431C68.2728 43.0148 70.4516 42.3647 72.6773 42.3751C74.1554 42.3742 75.619 42.6661 76.9837 43.234C78.3483 43.8019 79.587 44.6345 80.6281 45.6837C81.6692 46.733 82.4921 47.9781 83.0493 49.3471C83.6066 50.7162 83.887 52.182 83.8746 53.6601ZM82.0262 53.647C82.0284 51.7882 81.4797 49.9704 80.4495 48.4232C79.4193 46.8759 77.9538 45.6686 76.238 44.9537C74.5221 44.2388 72.633 44.0483 70.809 44.4063C68.985 44.7643 67.3079 45.6547 65.9896 46.9651C64.6712 48.2755 63.7707 49.9472 63.4017 51.769C63.0328 53.5908 63.2118 55.4812 63.9164 57.2013C64.6209 58.9215 65.8194 60.3942 67.3603 61.4338C68.9013 62.4733 70.7157 63.033 72.5745 63.042C73.816 63.0604 75.0487 62.8304 76.2 62.3655C77.3513 61.9006 78.3981 61.2102 79.2787 60.3348C80.1593 59.4595 80.8561 58.417 81.3279 57.2684C81.7998 56.1199 82.0372 54.8886 82.0262 53.647Z",
			fill: "#646464"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.5 47.013C74.5 47.5455 74.0253 47.9104 73.2154 47.9273C72.0812 47.9578 70.9754 48.2421 70.0054 48.7526C69.5901 48.9776 69.2009 49.2369 68.8432 49.5269C68.2486 49.9831 67.6859 49.9873 67.2553 49.5609C67.1593 49.4643 67.0876 49.3513 67.0451 49.2292C67.0025 49.1072 66.9899 48.9788 67.0081 48.8523C67.0263 48.7257 67.0749 48.6039 67.1508 48.4946C67.2267 48.3854 67.3281 48.2911 67.4486 48.218C69.0263 46.897 71.1275 46.15 73.3206 46.1305C73.4659 46.1167 73.6129 46.129 73.7525 46.1666C73.8921 46.2042 74.0212 46.2664 74.1318 46.3492C74.2425 46.432 74.3322 46.5336 74.3955 46.6478C74.4589 46.762 74.4945 46.8864 74.5 47.013Z",
			fill: "#646464"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.5,
			cy: 68.5,
			r: 3.5,
			fill: "#F5F4F4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17.5,
			cy: 77.5,
			r: 2.5,
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 87.5,
			cy: 2.5,
			r: 2.5,
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 106.5,
			cy: 8.5,
			r: 3.5,
			fill: "#EBEBEB"
		})
	]
});
export default SvgNoResultIcon;
